module.exports = __webpack_public_path__ + "static/media/table-inactive.12da0745.svg";